<template>
  <div class="box">
    <div class="introduce-body">
      <p class="Title">公司简介</p>
      <p class="introduce">
        {{ argument.companyProfile }}
      </p>
      <p class="Title">工商信息</p>
      <div class="tabulation">
        <!--  -->
        <div class="tabulation-top">
          <tr v-for="(item, index) in tabulationArr" :key="index">
            <th class="thOne">{{ item.title }}</th>
            <th class="thTwe">{{ item.content }}</th>
            <th class="thOne thTitle">{{ tabulationArr1[index].title }}</th>
            <th class="thTwe">{{ tabulationArr1[index].content }}</th>
          </tr>
        </div>
        <div class="tabulation-btm">
          <tr v-for="(item, index) in tabulationArr2" :key="index">
            <th class="th-long-tit">{{ item.title }}</th>
            <th class="th-long-con">{{ item.content }}</th>
          </tr>
        </div>
      </div>
      <p class="Title">公司地址</p>
      <!-- 公司地址  地图 -->
      <div class="map">
        <div class="map-box">
          <!-- 地址 /文字 -->
          <div class="map-Text" v-for="(item , index) in argument.companyInfoAddressVoList" :key="index">
            <div class="map-Text-left">
              <p class="orientation-icon"></p>
              {{item.companyFullAddress}}
            </div>
            <!-- <div class="map-Text-right">
              <p class="telephone-icon"></p>
              <p>138292832736</p>
              <p class="TheLetter-icon"></p>
              <p>138292832736@163.com</p>
            </div> -->
          </div>
          <!-- 地址 /地图 -->
          <!-- <div class="map-map"></div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    argument: {},
    tabulationArr: {},
    tabulationArr1: {},
    tabulationArr2: {},
   
  },
  data() {
    return {
      Address: [],
    };
  },
  created() {
    
  },
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>

<style scoped lang="less">
// 筛选区
.box {
  width: 100%;
  height: 100%;
  // min-height: 800px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 10px;
  display: flex;
  .introduce-body {
    width: 100%;
    margin: 20px;
    display: flex;
    flex-direction: column;
    // 标题
    .Title {
      width: 85px;
      height: 25px;
      font-family: PingFangSC-Medium;
      font-size: 18px;
      color: #333333;
      font-weight: 600;
      background-image: url("../../../../assets/imgs/zhuangshi@3x.svg");
      background-repeat: no-repeat;
      background-size: 100% 30%;
      background-position: 0px 16px;
      margin-bottom: 30px;
    }
    // 公司介绍
    .introduce {
      text-indent: 28px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #333333;
      line-height: 17px;
      font-weight: 400;
      line-height: 25px;
      margin-bottom: 30px;
    }
    // 工商信息
    .tabulation {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      border: 1px solid #eeeeee;
      .tabulation-top {
        width: 1110px;
        display: flex;
        flex-direction: column;
      }

      tr:nth-child(2n + 1) {
        background-color: #f2f2f2;
      }
      .thOne {
        width: 150px;
        height: 40px;
        border-right: 1px solid grey;
      }
      .thTitle {
        width: 150px;
        height: 40px;
        border-right: 1px solid grey;
        border-left: 1px solid grey;
      }
      .thTwe {
        height: 40px;
        width: 400px;
        color: #666666;
      }
      tr {
        width: 100%;
        height: 40px;
        line-height: 40px;
        font-family: PingFangSC-Medium;
        font-size: 15px;
        color: #333333;
        font-weight: 400;
      }
      // 下方长内容
      .tabulation-btm {
        tr {
          background-color: #f2f2f2;
        }
        tr:nth-child(2n + 1) {
          background-color: #ffffff;
        }
      }
      .th-long-tit {
        width: 150px;
        border-right: 1px solid grey;
      }
      .th-long-con {
        width: 950px;
        color: #666666;
      }
    }
    // 公司地址
    .map {
      width: 100%;
      // min-height: 10px;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      .map-box {
        height: 100%;
        margin: 20px;
        // 地址/文字
        .map-Text {
          width: 100%;
          height: 22px;
          line-height: 22px;
          display: flex;
          .map-Text-left {
            display: flex;
            flex: 1;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #409eff ;
            font-weight: 400;
            text-indent: 15px;
            .orientation-icon {
              width: 20px;
              height: 22px;
              background-image: url("../../../../assets/imgs/dingwei@3x.svg");
              background-size: 100% 100%;
            }
          }
          .map-Text-right {
            width: 400px;
            display: flex;
            justify-content: flex-end;
            p {
              font-family: PingFangSC-Medium;
              font-size: 12px;
              color: #333333;
              font-weight: 400;
            }
            .telephone-icon {
              width: 20px;
              height: 19px;
              background-image: url("../../../../assets/imgs/dianhua-weijiaohuan@3x.svg");
              background-size: 100% 100%;
              margin: auto 0;
              margin-right: 5px;
            }
            .TheLetter-icon {
              width: 20px;
              height: 15px;
              background-image: url("../../../../assets/imgs/youxiang@3x.svg");
              background-size: 100% 100%;
              margin: auto 0;
              margin-left: 30px;
              margin-right: 5px;
            }
          }
        }
        // 地址/地图
        .map-map {
          width: 100%;
          // height: 225px;
          background-image: url("../../../../assets/imgs/map.svg");
          background-size: 100% 100%;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
